/** Write all values before updating React state; roll back a partial quota failure. */
export function persistAgentValues(storage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>, values: Record<string, unknown>): void {
  const entries = Object.entries(values).map(([key, value]) => [key, JSON.stringify(value)] as const);
  const previous = entries.map(([key]) => [key, storage.getItem(key)] as const);
  let written = 0;
  try {
    for (const [key, value] of entries) { storage.setItem(key, value); written++; }
  } catch (error) {
    for (let i = written - 1; i >= 0; i--) {
      const [key, value] = previous[i];
      try { if (value === null) storage.removeItem(key); else storage.setItem(key, value); } catch { /* Surface the original save failure; never acknowledge this edit. */ }
    }
    throw new Error(`The change could not be saved on this device: ${error instanceof Error ? error.message : 'browser storage is unavailable'}`);
  }
}
